import styled from '@emotion/styled';
import { mediaQuery, responsiveFontSize } from '@presentation/styles';
import { Container } from '../../components';

export const TopSection = styled.section`
  background-color: ${(props) => props.theme.color.blue.lightBlue};
  position: relative;
  padding-top: 50px;
  padding-bottom: 150px;
  color: ${(props) => props.theme.color.blue.default};
  text-align: center;
`;

export const TopTitle = styled.h1`
  font-family: ${(props) => props.theme.font.alternate};
  font-weight: 600;
  ${responsiveFontSize(44, 6)}
  letter-spacing: 0;
  margin: 10px auto;

  ${mediaQuery('phone')} {
    font-size: 28px;
  }
`;

export const TopContainer = styled(Container)``;

export const TopSubtitle = styled.h2`
  ${responsiveFontSize(26, 2)}
  font-weight: 500;
  margin: 10px 0;
`;

export const TopDecoration = styled.img`
  bottom: 40px;
  bottom: 0px;
  left: 20px;
  max-width: 400px;
  position: absolute;

  ${mediaQuery('desktop')} {
    display: none;
  }
`;

export const TopSeparation = styled.img`
  position: absolute;
  z-index: 1;
  bottom: -40px;
  left: 0px;
  width: 100%;

  ${mediaQuery('max')} {
    bottom: 0px;
  }
`;

export const TopSearchCard = styled.div`
  max-width: 700px;
  width: 100%;
  margin: 75px auto;
  background-color: white;

  padding: 35px 40px;
  border-radius: 5px;
  color: ${(props) => props.theme.color.light.default};
  box-shadow: 0 3px 8px 0 rgba(0, 0, 48, 0.18);

  ${mediaQuery('phone')} {
    padding: 25px 30px;
    margin-top: 50px;
  }
`;

export const ScrollArrowWrapper = styled.div`
  pointer-events: none;
  position: relative;
  padding: 20px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 60px;

  /* ${mediaQuery('tablet')} {
    display: none;
  } */
`;

export const SliderContainer = styled(Container)`
  margin-top: 75px;
  margin-bottom: 75px;
`;

export const TestimonialsWrapper = styled.div`
  margin-top: 75px;
  margin-bottom: 75px;
`;

// STATS

export const StatsWrapper = styled.section`
  background: ${(props) => props.theme.color.light.tint};
  position: relative;
  padding-top: 60px;
  padding-bottom: 30px;
  margin-top: 125px;
  margin-bottom: 125px;
`;

export const StatsSeparationTop = styled.img`
  bottom: 99%;
  font-size: 0;
  left: 0;
  position: absolute;
  width: 100%;
  z-index: -1;
`;

export const StatsSeparationBottom = styled.img`
  bottom: auto;
  top: 99%;
  font-size: 0;
  left: 0;
  position: absolute;
  width: 100%;
  z-index: -1;
`;

export const StatsContainer = styled(Container)`
  padding: 0 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  margin: 0 auto;
  max-width: 700px;

  ${mediaQuery('small')} {
    flex-direction: column;
  }
`;

export const StatsItem = styled.div`
  padding: 20px 0;
  text-align: center;
  ${responsiveFontSize(24, 2)};
  font-weight: 700;
`;

export const StatsValue = styled.span`
  display: block;
  color: ${(props) => props.theme.color.purple.default};
  font-family: ${(props) => props.theme.font.alternate};
  font-weight: 700;
  ${responsiveFontSize(50, 4)};
  letter-spacing: 0;
`;

export const StatsLegend = styled.span`
  display: block;
  font-size: 14px;
  margin: auto;
  margin-top: 35px;
  text-align: center;
  width: 90%;
`;
